import { Store, StoreConfig } from '@datorama/akita';
import { Injectable } from '@angular/core';
import { User } from 'projects/core/src/lib/login/data/user';
import { TimeCard } from 'projects/app-misc/src/app/modules/punch-time-widget/data/time-card';
import { UserProfile } from 'projects/app-misc/src/app/modules/profile/utils/profile.utils';
import { UserRole } from 'projects/core/src/lib/login/data/user-role';
import { UserService } from 'projects/core/src/lib/login/data/user.service';

export interface AppState {
  choosenUser: User;
  currentUser: User;
  userProfile: UserProfile;
  userRole: UserRole[];
  rolesAccessMap: Map<string, string[]>;
  initialized: boolean;
  authorized: boolean;
  wsSocketReady: boolean;
  lastTimeCard: TimeCard;
}

@Injectable({
  providedIn: 'root'
})
@StoreConfig({name: 'app-state'})
export class AppStateStore extends Store<AppState> {
  constructor(
    private userService: UserService
  ) {
    super({
      currentUser: null,
      userRole: [],
      initialized: false,
      authorized: false,
      wsSocketReady: false,
      rolesAccessMap: new Map()
    });
  }

  updateRolesMap(rolesAccessMap: Map<string, string[]>) {
    this.update({
      ...this._value(),
      rolesAccessMap
    })
  }


  updateChoosenUser(choosenUser: User) {
    this.update({
      ...this._value(),
      choosenUser
    })
  }

  updateCurrentUser(currentUser: User) {
    if(currentUser.roles) {
      currentUser.roles.forEach(role => {
        if(role.name === 'Admin') {
          currentUser.adminRole = true;
          currentUser.adminNSales = true;
          currentUser.adminNSuperV = true;
          currentUser.adminNSuperNSales = true;
          currentUser.canSeeProposal = true;
        }
        if(role.name === 'SalesPerson') {
          currentUser.adminNSales = true;
          currentUser.engineerNSales = true;
          currentUser.adminNSuperNSales = true;
          currentUser.canSeeProposal = true;
        }
        if(role.name === 'CVEngineer') {
          currentUser.engineerNSales = true;
          currentUser.canSeeProposal = true;
        }
        if(role.name === 'ShopSupervisor') {
          currentUser.adminNSuperV = true;
          currentUser.adminNSuperNSales = true;
          currentUser.canSeeProposal = true;
        }
        if(role.name === 'MaterialManager') {
          currentUser.materialManagerRole = true;
          currentUser.canSeeProposal = true;
        }
        if (role.name === 'Developer' || role.name === 'ServiceManager') {
          currentUser.serviceManagerUser = true;
        }
        if (role.name === 'Service Department') {
          currentUser.serviceDepartmentUser = true;
        }
      })

      if(!currentUser.adminRole && !currentUser.adminNSuperV && !currentUser.adminNSales && currentUser.roles.find(role => role.name === 'InstallationUser')) {
        currentUser.installationUser = true;
      }
    }

    this.update({
      ...this._value(),
      currentUser
    })
    this.updateUserRole(currentUser.roles)
  }

  updateUserRole(userRole: UserRole[]) {
    this.update({
      ...this._value(),
      userRole
    })
  }

  updateUserProfile(userProfile: UserProfile) {
    this.update({
      ...this._value(),
      userProfile
    })
  }


  updateInitializedStatus(initialized: boolean) {
    this.update({
      ...this._value(),
      initialized
    })
  }

  updateAutorizedStatus(authorized: boolean) {
    this.update({
      ...this._value(),
      authorized
    })
  }
}
